import { showAlert } from "../components/common/ErrorAlert/ErrorAlert";
import api from "./api";

export async function routeList(id = null, params={}) {
    try {
      if (id) {
        const response = await api.get(`/route/routes/?id=${id}`);
        return response;
      } else {
        const response = await api.get("/route/routes/", {params});
        return response;
      }
    } catch (error) {
      throw error;
      console.log("Error fetching route list: ", error);
    }
  }


export async function routeArchive(id, id_list) {
  try {
      let response;
      if (id_list) {
          response = await api.post('route/archive/', {
            id_list: id_list,     
          });
      } else {
          response = await api.get(`route/archive/?id=${id}`);
      }
      return response;
  } catch (error) {
    showAlert(error.response.data?.message);
      // console.log("Error Archiving Penalties: ", error);
  }
}

export async function RouteDelete(id) {
  try{
    const response = await api.delete(`route/delete/${id}/`);
    return response
  }catch(error){
    throw error
  }    
}

export async function customers(params) {
  try{
      const response = await api.get('customer/',{params:params});
      return response
  }catch(error){
    console.log("Error Fetching customers")
  }
}

export async function routeTypes() {
  try{
      const response = await api.get('route/types/');
      return response
  }catch(error){
    console.log("Error fetching route types")
  }
}

export async function AddRoute(payload) {
  try{
    const response = await api.post('route/create/',payload);
    return response
    
  }catch(error){
    
    throw error;
    
  }
}


export async function RouteDetail(roueId){
  try{
    const response = await api.get(`route/detail/${roueId}/`);
    return response
  }catch (error) {
    throw error;
  }
}



export async function GetMap(payload) {
  try{
    const response = await api.post('route/map/',payload);
    return response
  }catch(error){
    throw error;
    console.log("Error in fetching map")
  }
}

export async function EditRoute(id, payload) {
  try{
    const response = await api.put(`route/update/${id}/`,payload);
    return response
  }catch(error){
    throw error;
    console.log("Error Editing route")
  } 
}

export async function RouteAssignAdd(payload) {
  try {
    const response = await api.post('route/assign/create/', payload);
    return response;
  } catch (error) {
    throw error;   // 🔥 MUST THROW
  }
}

export async function getRouteAssign(id = null, params = {}) {
  try {
    console.log(id)
    if (id) {
      const response = await api.get(`/route/assign/detail/${id}/`);
      return response;
    } else {
      const response = await api.get("/route/assignments/", { params });
      return response;
    }
  } catch (error) {
    throw error;
  }
}

export async function RouteAssignEdit(id,payload) {
  try{
    const response = await api.put(`route/assign/update/${id}/`,payload);
    return response
  }catch(error){
    throw error;
    console.log(error)
  } 
}


export async function ArchiveAssignedRoute(id, id_list) {
  try {
      let response;
      if (id_list) {
          response = await api.post('route/assign/archive/', {
            id_list: id_list,     
          });
      } else {
          response = await api.get(`route/assign/archive/?id=${id}`);
      }
      return response;
  } catch (error) {
    showAlert(error.response.data?.message);
      console.log("Error Archiving Route Assignment: ", error);
  }
}

export async function DeleteRouteAssign(id) {
    try {
        return await api.delete(`route/assign/delete/${id}/`);
    } catch (error) {
      throw error;
        console.error("Error deleting route assignment:", error);
    }
}

export async function getActiveRoutes() {
  try {
    const response = await api.get("/route/active/");
    return response;
  } catch (error) {
    console.log("Error fetching active routes: ", error);
  }
}